/**
 * Returns a template tag that escapes all interpolations using `fn`. Example
 * usage:
 *
 *     escape(encodeURIComponent)`/users/${user}`
 */
export default function escape(
  fn: (input: string) => string,
): (literals: TemplateStringsArray, ...interpolations: string[]) => string {
  // There’s always one more literal than interpolations.
  return (literals: TemplateStringsArray, ...interpolations: string[]) =>
    [
      ...interpolations.map(
        (interpolation, index) => `${literals[index]}${fn(interpolation)}`,
      ),
      literals[literals.length - 1],
    ].join('');
}
